import { useEventCount } from 'modules/socket/hooks'
import { OptionItem } from '../types'
import { useFilteredOptionsByPerms } from '../utils'
import { OPTIONS } from './CommonOptions'
import useMenuOptions from './useMenuOptions'

export const MOBILE_OPTIONS: OptionItem[] = [
  {
    translateKey: 'main',
    key: 'main',
    children: [OPTIONS.MY_TASKS, OPTIONS.BIDS, OPTIONS.DEALS, OPTIONS.US_CONTRACTS, OPTIONS.DISPATCHING],
  },
  {
    translateKey: 'usersAndCompanies',
    key: 'usersAndCompanies',
    children: [
      OPTIONS.MATCHES,
      OPTIONS.DASHBOARD,
      OPTIONS.SIGMA_DPR,
      OPTIONS.SIGMA_PL,
      OPTIONS.SIGMA_DAILY,
      OPTIONS.SIGMA_NEW_CONTRACTS,
      OPTIONS.SIGMA_UNSHIPPED,
      OPTIONS.USERS,
      OPTIONS.COMPANIES,
      OPTIONS.TEAMS,
      OPTIONS.SELLER_POTENTIAL,
      OPTIONS.CALLS_LIST,
      OPTIONS.CALL_STATISTICS,
      OPTIONS.WHATS_APP,
    ],
  },
  {
    translateKey: 'logisticsMob',
    key: 'logisticsMob',
    children: [
      OPTIONS.CARRIERS,
      OPTIONS.LOGISTICS_DASHBOARD,
      OPTIONS.CUSTOMERS,
      OPTIONS.WAREHOUSES,
      OPTIONS.ELEVATORS,
      OPTIONS.CARS,
      OPTIONS.PAYMENT_ORDERS,
      OPTIONS.RATES,
      OPTIONS.EXPORT,
    ],
  },
  {
    translateKey: 'documentsMob',
    key: 'documentsMob',
    children: [
      OPTIONS.SPECIFICATIONS,
      OPTIONS.DOCUMENTS_LIST,
      OPTIONS.CONTRACTS,
      OPTIONS.SAMPLES,
      OPTIONS.SDIZ,
      OPTIONS.DOC_INDEX,
    ],
  },
]

export const useMobileOptions = () => {
  const filteredByPerms = useFilteredOptionsByPerms(MOBILE_OPTIONS)

  const eventsCount = useEventCount()
  const { menuOptions } = useMenuOptions(eventsCount, filteredByPerms, true)

  return { menuOptions }
}
